"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getInitializedPlugins = exports.getEnabledPlugins = exports.enablePlugins = void 0;
const constants_1 = require("./constants");
const lodash_merge_1 = __importDefault(require("lodash.merge"));
const custom_1 = require("./custom");
/**
 * Enables all plugins that need manual enablement
 *
 * @param enabledPlugins default plugins that are enabled
 */
const enablePlugins = (enabledPlugins) => {
    enabledPlugins.forEach((plugin) => {
        if (plugin.enablePlugin !== undefined) {
            plugin.enableConfiguration === undefined
                ? plugin.enablePlugin()
                : plugin.enablePlugin(plugin.enableConfiguration);
        }
    });
};
exports.enablePlugins = enablePlugins;
/**
 * Filters the combined object maps for just the enabled plugins
 *
 * @param pluginConfiguration - plugin configuration options passed in by the user
 * @param isGtmEnabled - if the app opts in to GTM manually, include the Plugin as an enabled plugin
 */
const getEnabledPlugins = (pluginConfiguration = {}, isGtmEnabled = false) => {
    // Gets Default Plugins that apps have to Opt Out of
    const map = getPluginMap(pluginConfiguration.defaultPluginConfigurationOverrides);
    const enabledDefaultPlugins = Object.values(map).filter((plugin) => {
        return plugin.enabled;
    });
    // Adds the GoogleTagManager plugin if enabled
    let enabledPlugins;
    if (isGtmEnabled) {
        enabledPlugins = [
            ...enabledDefaultPlugins,
            { enabled: true, plugin: custom_1.googleTagManagerDataInjectionPlugin },
        ];
    }
    else {
        enabledPlugins = enabledDefaultPlugins;
    }
    if (pluginConfiguration.additionalPlugins !== undefined) {
        return [...enabledPlugins, ...pluginConfiguration.additionalPlugins];
    }
    return enabledPlugins;
};
exports.getEnabledPlugins = getEnabledPlugins;
/**
 * Creates the BrowserPlugin[] list to be instantiated in the Snowplow tracker
 *
 * @param enabledPlugins default plugins that are enabled
 */
const getInitializedPlugins = (enabledPlugins) => {
    return enabledPlugins.map((plugin) => {
        if (plugin.plugin !== undefined) {
            return plugin.plugin();
        }
        return {};
    });
};
exports.getInitializedPlugins = getInitializedPlugins;
/**
 * Combines the default plugins map with a user supplied override, if one is present
 *
 * @param defaultPluginOverrides - any overrides to the default plugins passed in by the user
 */
const getPluginMap = (defaultPluginOverrides = {}) => {
    return (0, lodash_merge_1.default)(constants_1.DEFAULT_PLUGINS, defaultPluginOverrides);
};
//# sourceMappingURL=data:application/json;base64,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


// WEBPACK FOOTER //
// ../../../src/plugins/utils.ts